export const appVersion = "v1.3.10";


export const checkInPrompts = [
    "If recovery had a theme song, what would yours be?",
    "If today had a motivational slogan, what would it be?",
    "If today’s progress felt slow, what’s one thing that still went right?",
    "If you could send a message to your future self, what would it say?",
    "If your knee could talk, what encouraging words would it say to you?",
    "What’s a challenge you faced today—and how did you handle it?",
    "What’s a goal you’re working toward that makes all of this worth it?",
    "What’s a little way you’ve taken care of yourself recently?",
    "What’s a moment from today that made you feel hopeful?",
    "What’s a movement milestone you’re excited to hit next?",
    "What’s a piece of advice you’d give to someone just starting their recovery?",
    "What’s a small act of kindness you can do for yourself today?",
    "What’s a song that perfectly matches your “keep going” energy right now?",
    "What’s a way you’ve surprised yourself with your strength lately?",
    "What’s one movement that feels easier today than it did last week?",
    "What’s one movement you can do today that you couldn’t last month?",
    "What’s one reminder you want to carry with you into tomorrow?",
    "What’s one small win you had recently that deserves a little celebration?",
    "What’s one thing you love about how your body supports you?",
    "What’s one thing you’re looking forward to doing pain-free again?",
    "What’s one thing you’ve learned about yourself during this journey?",
    "What’s one word that describes how you want to feel by the end of today?",
    "What’s something outside of recovery that made you smile today?",
    "What’s something that helps you reset when you’re feeling frustrated?",
    "What’s something you did today that your past self would be proud of?",
    "What’s something you once thought was impossible that you can do now?",
    "What’s something you’re grateful for today—big or small?",
    "What’s something you’ve realized about healing that you didn’t expect?",
    "What’s something your body did today that made you feel proud?",
    "Who’s someone in your corner cheering you on? (Don’t forget to thank them!)",
    "How are you feeling today? Good or bad — let’s talk about it!",
    "What’s one thing you’ve done recently that made you feel proud of yourself? Even small wins count!",
    "Are you noticing any progress in how you’re feeling or moving?",
    "What’s been the toughest part of your journey lately? It’s important to acknowledge those moments too.",
    "Have you had moments where you’ve felt stronger or more capable? What do you think helped make that happen?",
    "What’s one thing that’s been bringing you joy or comfort during this journey?",
    "Are there any aches or pains that feel different today? Let’s focus on what your body’s telling you.",
    "What’s been the most helpful part of your routine so far?",
    "Have you been able to rest and recharge? What could make your downtime even better for you?",
    "What’s something you’re excited to get back to once you’re feeling better? Let’s keep that as your inspiration!",
    "What’s one thing you’ve learned about your strength or resilience through this process?",
    "Are there times when you feel stuck or unsure about what to do next? Share more about it.",
    "What’s been your go-to way to stay calm or find balance when things feel overwhelming?",
    "Is there something you’d like more clarity or help with? You don’t have to figure it all out alone.",
    "What’s a small win you’ve had recently that we can build on today?",
    "What’s one piece of advice or encouragement you’d give to yourself right now?",
    "What’s been the best part of your week so far? Let’s keep that positive energy going!",
    "Is there a way you’ve surprised yourself recently with your strength or progress?",
    "What’s a way you’ve taken care of yourself recently that made a difference?",
    "If you could give yourself credit for one thing today, what would it be? You deserve to celebrate every step!",
];

export const quoteMessage = [
  "Like the song says, ‘Nothing’s gonna stop us now!’ You’ve got this!",
  "Every journey starts with a single step. Today, you’re taking yours!",
  "If you’re waiting for a sign to keep going—this is it!",
  "Progress isn’t about doing more. It’s about doing what matters.",
  "One small step for your knee, one giant leap for your comeback.",
  "If your knee could talk, it’d say, 'Alright, let’s do this!'",
  "Your best is enough. And some days, your best is just showing up.",
  "Small wins lead to big comebacks. And yes, getting off the couch counts.",
  "If knees could talk, yours would be saying, 'Finally, we’re doing this right.'",
  "Rehab is a lot like laundry—you can ignore it, but it’s not going anywhere.",
];

export const typingSet = [
  [
    "Recovery takes time—so does getting you the best answer!",
    "Checking this against your journey…",
    "Hang tight...",
    "Almost there…",
    "Here we go!",
  ],
  [
    "Every step counts—including this one!",
    "Lining this up with your journey…",
    "Hold on, double-checking…",
    "Almost ready…",
    "I got this!",
  ],
  [
    "Knees need patience—so do great answers!",
    "Piecing this together just for you…",
    "Hang tight, almost there…",
    "A few more seconds…",
    "And voilà!",
  ],
  [
    "I've got you—let's make this count!",
    "Tailoring this to your recovery…",
    "Just about ready…",
    "Hang tight!",
    "Here it is!",
  ],
  [
    "Your recovery, your pace—let's do this right!",
    "Aligning this with your personal goals…",
    "Fine-tuning for you…",
    "Locking in the best insights!",
    "All set!",
  ],
];

export const preventionFAQs = [
  "Is knee pain always a sign that surgery is needed?",
  "What are the main causes of knee damage that lead to surgery?",
  "Can weight loss really help prevent knee surgery?",
  "What exercises help prevent knee problems and surgery?",
  "What can I do TODAY to start protecting my knees?",
  "How does diet affect knee health and surgery prevention?",
  "Can regenerative treatments like PRP or stem cells prevent knee replacement?",
  "Is it true that running causes knee damage and leads to surgery?",
  "How do I know if it’s time to consider knee surgery?",
  "Do knee braces actually prevent surgery?",
  "Best sleeping positions to reduce knee pain?",
  "Common mistakes when trying to avoid knee surgery?"
];
export const preopFAQs = [
  "What should I expect before knee surgery?",
  "How do I prepare my home for post-surgery recovery?",
  "What are the risks associated with knee surgery?",
  "How long will I be in the hospital after knee surgery?",
  "What type of anesthesia will be used during my surgery?",
  "Will I need physical therapy before my surgery?",
  "How can I manage anxiety about my upcoming surgery?",
  "What should I bring to the hospital on the day of surgery?",
  "How do I arrange for help at home after surgery?",
  "What dietary changes should I make before surgery?",
  "Are there any medications I should stop taking before surgery?",
  "What questions should I ask my surgeon before the procedure?"
];
export const postopFAQs_1stQ = [
  "How often should I ice or elevate my knee?",
  "When should I have my follow up visit to my doctor?",
  "Is it normal to have swelling around my knee?",
  "When should I stop my pain medication?",
  "When should I be worried about signs of infection or complications?",
  "Why can't I sleep?",
  "Why does my leg feel so heavy?",
  "When can I remove the surgical dressing?",
  "What's the best sitting or sleeping position?",
  "Can I go up and down the stairs now?",
  "How can I prevent scar tissue from limiting my range of motion?",
  "Should I still be using a walker or cane?"
];
export const postopFAQs_2ndQ = [
  "How much range of motion (ROM) should I have at this stage?",
  "How long will I need to continue physical therapy?",
  "How much walking should I be doing?",
  "Is it normal to still feel some discomfort or stiffness?",
  "Can I kneel on my new knee yet?",
  "Do I still need to stretch?",
  "Why is my ROM not improving?",
  "Can I resume sports or higher-impact activities like hiking or tennis?",
  "Is it safe to travel long distances or fly?",
  "When can I resume sexual activities?",
  "Can I drive again now?",
  "When can I return to work?"
];

export const romNotFoundMessage = [
  "Our sensors can’t find your ROM… it might be hiding. Give it a stretch!",
  "ROM not spotted. Time to strike a pose!",
  "Your ROM is playing hide-and-seek — move so we can catch it!",
  "Scanning… scanning… nope, your ROM’s still off the grid.",
  "ROM missing. Maybe it needs a little wave hello?",
  "We can’t detect your ROM — it might be camera shy.",
  "ROM alert: We’re detecting… absolutely nothing.",
  "The ROM signal is weak. Show us your moves!"
];

export const postopFAQs_3rdQ = [
  "Why am I still in pain after more than 3 months?",
  "When will I feel fully “normal” again?",
  "Why do I need to maintain flexibility and strength moving forward?",
  "Are there any long-term risks or limitations with my new knee?",
  "What should I do if my recovery seems to be stalling?",
  "Why do I still have stiffness, and will it ever fully go away?",
  "Can I resume all activities, including high-impact sports like running or skiing?",
  "Should I keep seeing a physical therapist or monitor my progress?",
  "Is it normal to feel fatigue after certain activities?",
  "What should I focus on to keep my knee strong and healthy long-term?",
  "Why does my leg still feel this heavy?"
];
export const messageSets = [
  [
    "Recovery takes time—so does getting you the best answer!",
    "Checking this against your journey…",
    "Hang tight...",
    "Almost there…",
    "Here we go!",
  ],
  [
    "Every step counts—including this one!",
    "Lining this up with your journey…",
    "Hold on, double-checking…",
    "Almost ready…",
    "I got this!",
  ],
  [
    "Knees need patience—so do great answers!",
    "Piecing this together just for you…",
    "Hang tight, almost there…",
    "A few more seconds…",
    "And voilà!",
  ],
  [
    "I've got you—let's make this count!",
    "Tailoring this to your recovery…",
    "Just about ready…",
    "Hang tight!",
    "Here it is!",
  ],
  [
    "Your recovery, your pace—let's do this right!",
    "Aligning this with your personal goals…",
    "Fine-tuning for you…",
    "Locking in the best insights!",
    "All set!",
  ],
];



